import {Suspense} from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './lib/helpers/i18n';
import Loading from 'components/common/Loading';

// import * as serviceWorker from './serviceWorker';

ReactDOM.render(
  <Suspense fallback={<Loading />}>
    <App />
  </Suspense>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();
